import {createReactionMenu} from '../../shared/social/reaction-menu';
import { Injectable } from '@angular/core';
import {ReactionSubjectInterface} from "../../shared/timeline/timeline-tile/reaction-subject.interface";
import {SpeedDialComponent} from "../../shared/speed-dial/speed-dial.component";
import {ReactionApiModel} from "../../api/models/reaction.api.model";
import {UserApiModel} from "../../api/models/user.api-model";
import {ReactionTypeEnum} from "../enums/reaction-type.enum";
import {ReactedWithEnum} from "../enums/reacted-with.enum";
import {Observable, Subscription} from "rxjs";
import {plainToClass} from "class-transformer";
import {ReactionRestService} from "../../api/services/reaction.rest.service";
import {map, take, tap} from "rxjs/operators";
import {HttpResponse} from "@angular/common/http";
import {MenuItem} from "primeng/api";
import {TokenDataProviderService} from "./token-data-provider.service";
import {CurrentUserViewModel} from "../models/current-user.view-model";

@Injectable({
  providedIn: 'root'
})
export class ReactionService {

  public reactionType: ReactionTypeEnum;
  public reactionSubject: ReactionSubjectInterface;
  public subscriptions: Subscription[] = [];
  public items: MenuItem[];
  public currentUser: CurrentUserViewModel

  constructor(
    private reactionRS: ReactionRestService,
    private tokenDPS: TokenDataProviderService
  ) {
    tokenDPS.currentUser.subscribe((currentUser: CurrentUserViewModel) => this.currentUser = currentUser)
    this.items = createReactionMenu(reactedWith => {
      this.createReaction(reactedWith, this.reactionSubject, this.reactionType).pipe(take(1))
        .subscribe(reaction => this.syncReaction(reaction));
    });
  }

  public toggleThumbsUp(e, subject: ReactionSubjectInterface, type: ReactionTypeEnum, speedDial: SpeedDialComponent): Observable<ReactionApiModel> {
    e.preventDefault();
    this.reactionType = type;
    this.reactionSubject = subject;
    let sub: Subscription;

    if (speedDial.visible) {
      return;
    }

    if (subject.currentUserReaction) {
      sub =  this.removeReaction(subject.currentUserReaction).pipe(tap(() => {
        subject.reactions = subject.reactions.filter((x: ReactionApiModel) => (x.author as UserApiModel)['@id'] !== (subject.currentUserReaction.author as UserApiModel)['@id']);
        subject.currentUserReaction = null;
      })).subscribe(() => {
        sub.unsubscribe();
      });
      return;
    }

    sub = this.createReaction(ReactedWithEnum.THUMBS_UP, subject, this.reactionType).pipe(tap((reactionAM: ReactionApiModel) => {
      this.syncReaction(reactionAM);
    })).subscribe(() => sub.unsubscribe());
  }

  public toggleReactionBtn(e, subject: ReactionSubjectInterface, type: ReactionTypeEnum, speedDial: SpeedDialComponent) {
    e.preventDefault();
    this.reactionType = type;
    this.reactionSubject = subject;
    speedDial.onButtonClick(e);
  }

  public createReaction(reactedWith: string, subject: ReactionSubjectInterface, type: ReactionTypeEnum): Observable<ReactionApiModel> {
    return this.reactionRS
      .create(plainToClass(ReactionApiModel, {reactedWith, subject: subject['@id'], type}));
  }

  public removeReaction(reactionAM: ReactionApiModel): Observable<HttpResponse<object>> {
    return this.reactionRS.delete(reactionAM);
  }

  public syncReaction(reactionAM: ReactionApiModel): void {
    this.reactionSubject.reactions = this.reactionSubject.reactions.filter((x: ReactionApiModel) => (x.author as UserApiModel)['@id'] !== (reactionAM.author as UserApiModel)['@id']);
    this.reactionSubject.reactions.unshift(reactionAM);
    this.syncIsReacted();
  }

  public syncIsReacted(): void {
    this.reactionSubject.currentUserReaction = this.reactionSubject.reactions?.find((x: ReactionApiModel) => (x.author as UserApiModel)['@id'] === this.currentUser['@id']);
  }
}
